goog.provide('el8.appchart.mainFeeds.chart');

goog.require('el8.appchart.mainFeeds.actions');
goog.require('el8.appchart.mainFeeds.chartAddlRenderItemFn');
goog.require('el8.appchart.mainFeeds.ChartFeed');
goog.require('el8.appchart.mainFeeds.chartFeedReactRenderMap');
goog.require('el8.appchart.mainFeeds.chartFetch');
goog.require('el8.appchart.mainFeeds.chartRenderer');
goog.require('el8.appshared.docTags.tooltips');
goog.require('el8.appshared.letterFeedRenderer');
goog.require('el8.template.appchart.mainFeeds');
goog.require('el8.service.tz');
goog.require('el8.util.base');
goog.require('el8.util.consts');
goog.require('el8.util.feed');
goog.require('el8.util.format');


/**
 * See https://github.com/elationemr/hippo/wiki/Chart-Feed
 * for an overview of the various pieces of the chart feed
 */
if (el8Globals['APP'].startswith('chart')) {

    el8.appchart.mainFeeds.chart = new el8.appchart.mainFeeds.ChartFeed({
        container: $('#chart-feed-container'),
        scrollContainer: $('#main-feed-container'),
        name: 'chart',
        urlIndex: el8Globals['PATIENT_PATH'] + 'chart-feed-index/',
        urlFilter: el8Globals['PATIENT_PATH'] + 'search-chart-feed/',
        emptyTemplateFn: el8.template.appchart.mainFeeds.emptyChart,
        emptySearchMsg: 'No matching items found',
        errorMsg: 'Chart search is currently not operating. Our engineers have been notified and will have it fixed shortly.',
        rendererFn: function(item, indexedItem) {
            if (item) {
                // if parent feed has _sortByProviderActivity set, pass it down to the renderer
                // if not set, then default to false.
                if (this._parentFeed.hasOwnProperty('_sortByProviderActivity')) {
                    item['sortByProviderActivity'] = this._parentFeed._sortByProviderActivity;
                } else {
                    item['sortByProviderActivity'] = false;
                }
            }
            return el8.appchart.mainFeeds.chartRenderer(item, indexedItem);
        },
        reactRenderMap: el8.appchart.mainFeeds.chartFeedReactRenderMap,
        fetchFn: el8.appchart.mainFeeds.chartFetch,
        pageSize: el8.util.consts.CHART_FEED_PAGESIZE,
        skeletonFn: el8.template.appchart.mainFeeds.chart,
        moreTrigger: '#chart-feed-more-trigger',
        clickTriggerMap: el8.appchart.mainFeeds.actions.clickMap,
        addlRenderItemFn: el8.appchart.mainFeeds.chartAddlRenderItemFn,
        addlResetItemFn: function(item, renderedItem) {
            if (!item) return;

            if (item.isPlr === true || (typeof item.isPlr === "function" && item.isPlr())) { return; }

            if (item.is('VisitNote') && el8Globals.ELATIONSTAFF) {
                el8.appchart.mainFeeds.billElationStaffRenderer.reset(renderedItem);
            }

            if (item.is('Letter') || item.is('LetterReceipt')) {
                if (renderedItem.length) { // renderedItem will be empty on first render
                    // this block is chart-feed specific, so it doesn't live in letterFeedRenderer
                    var letterCollapsed = Boolean($('.letter-collapsible-section', renderedItem).attr('_collapsed'));
                    item.setChartItemExpanded(!letterCollapsed);
                }
                el8.appshared.letterFeedRenderer.reset(renderedItem, item);
            } else if (item.is('VisitNote') || item.is('NonvisitNote') || item.is('Report')) {
                _(renderedItem.find('.doctag-coded.has-tippy')).each(function (span) {
                    el8.appshared.docTags.tooltips.destroy(span);
                });
            } else if (item.is('MedOrder')) {
              // Destroy surescripts explanation tooltip
              el8.service.tooltip.destroy($('.explain-surescripts-trigger', renderedItem));
            }
        },
        // filterFieldSelector: '#chart-feed-search-input',
        // filterFieldInfoText: 'Search Chronological Record...',
        // filterBtn: '#chart-feed-search-btn',
        // clearFilterBtn: '#chart-feed-search-clear-btn',
        filterNoBind: true, // we manually set up and bind the new VisualSearch widget
        filterIndexProp: 'feed_index',
        preProcessIndexFn: function(index) {
            var that = this;
            var sortedIndex = index.slice(0);
            sortedIndex.forEach(function(item) {
                if (that._sortByProviderActivity) {
                    item.sortDate_obj = el8.service.tz.newTzDateTime(item.feed_date);
                } else {
                    // For sorting by patient activities, We'll use
                    // documentDate if available
                    if (item.documentDate) {
                        item.sortDate_obj = el8.service.tz.newTzDateTime(item.documentDate);
                    } else {
                        item.sortDate_obj = el8.service.tz.newTzDateTime(item.feed_date);
                    }
                }
            });

            sortedIndex.sort( function(x, y) {
                if (x.sortDate_obj < y.sortDate_obj) { return 1; }
                else if (x.sortDate_obj > y.sortDate_obj) { return -1; }
                else { return 0; }
            });
            return sortedIndex;
        },
        infiniteScroll: true
    });
}
